import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CreditCard, CreditCardValidators } from 'angular-cc-library';
import { ActivatedRoute, Router } from '@angular/router';
import { REGEX } from 'src/app/constants/regex';
import { defer } from 'rxjs';
import { map } from 'rxjs/operators';
import { DataFlightService, DataService, HttpService, UtilityService } from '../../services';
import { GSTComponent } from './gst/gst.component';
import { ProcessComponent } from 'src/app/components/process/process.component';
import { FilterPipe } from '../../pipe'


@Component({
  selector: 'app-payment-design',
  templateUrl: './payment-design.component.html',
  styleUrls: ['./payment-design.component.scss']
})
export class PaymentDesignComponent implements OnInit {
  bank_list_: any = [];

  internet_banking_code;

  internet_disabled: boolean = true;

  mastercard = 'CC';
  checked = true;
  selectedItem: any = "";
  selectedItemUpi: any = "";
  selectedItemNetBanking: any = '';
  errMsg;
  bookingID:any="";
  bookingdata:any="";
  Book:any="";
  booking_ID:any="";
  payment:any="";
  bookingDetail:any="";
  bookingData:any="";
  bookedDetail:any="";
  bookedRoom:any="";
  pay:any="";
  rP:any="";
  ROOM:any="";
  month = this.data.getMonth;
  year = this.util.getYearsFromCurrent();
  list = this.data.gstInfo;
  paymentForm: FormGroup;
  upiPayment: FormGroup;
  walletsPayment: FormGroup;
  net_banking_Payment: FormGroup;
  card_number;
  optPaymentRoute;
  payment_type = this.data.payment_option;
  wallet = this.data.wallet;
  upiList =  this.data.upi;
  net_banking = this.data.net_banking;
  checkedWallets: boolean = true;
  checkedUpi: boolean = true;
  checked_net_banking: boolean = true;
  upi_banking_number  = new FormControl('', Validators.required);
  test_tearm_condition: FormControl;
  conv_fee_upiBank: any = [];
  list__: any = [];
  disabled: boolean = true;
  card_disabled: boolean = true;
  selectedWalletItem: any = null;
  selectedWallet;
  wallet_banking;
  term:string = "";
  internet_banking_: any = "";
  conv_fee_wallet: any = [];
  wallets_disabled: boolean = true;
  wallets_banking_: any = '';
  wallets_banking_value = new FormControl('', Validators.required);
  wallets_tearm_condition = new FormControl('', Validators.required);
  net_banking_value = new FormControl('', Validators.required);
  selectedBank;
  conv_fee_internetBank: any = [];
  internet_tearm_condition = new FormControl('', Validators.required);
  totalRoomPrice;
  Passanger_details: any = [];



  // paymentWallet = new FormControl ( '', Validators.required );
  // paymentNetBanking = new FormControl ( '', Validators.required );

  constructor(public data: DataService, public dialog: MatDialog,  public router: Router, private route: ActivatedRoute,public data_f: DataFlightService, public http: HttpService, private fb: FormBuilder, public util: UtilityService) {
    this.bookingID = JSON.parse(localStorage.getItem('bookingId')!);
    const Passanger_details = JSON.parse(localStorage.getItem('hotelPassanger_details')!);
    const passangerDetails = Passanger_details.room_detail;
    this.Passanger_details = passangerDetails;
    this.http.hotelget(`payment-gateway/payment-mode-list`).subscribe(res => {
      if(res.code === 2000) {
        this.bank_list_ = res.data
        console.log("this.bank_list_", this.bank_list_);
        this.internet_banking_ = this.bank_list_['net_banking'].map(i => {
          return { ...i, logo: this.data_f.getBankIcon(i.name) }
        });
        this.wallet = this.bank_list_['wallets'].map(i => {
          return { ...i, logo: this.data_f.getBankIcon(i.name) }
        });
        console.log("this.internet_banking_", this.internet_banking_);
        const roomDetails = JSON.parse(localStorage.getItem('room_booking_'));
        this.totalRoomPrice = roomDetails.room_details_.price_list.total_rooms_gross_price.total_price;
        console.log(this.totalRoomPrice); 
        // document.getElementById('totalPrice').innerText = totalRoomPrice;
      }
    }, err => {
      this.util.errorMessage(err)
    })
    this.paymentForm = this.fb.group ({
      booking_id: this.bookingID,
      payment_gateway_id: new FormControl ('1'),
      payment_mode: new FormControl ('CC'),
      card_type: new FormControl ('CC'),
      card_number: new FormControl('', [Validators.required, CreditCardValidators.validateCCNumber]),
      card_exp_month: new FormControl ('', Validators.required),
      card_exp_year: new FormControl ('', Validators.required),
      card_cvv: new FormControl ( '', Validators.required ),
      card_holder_name: new FormControl ( '' ),
      termsServices: new FormControl (''),
      // paymentWallet: this.paymentWallet,
      // paymentNetBanking: this.paymentNetBanking,
    });
    this.walletsPayment = this.fb.group ({
      termCondtion: new FormControl('', Validators.required),
      wallets_number: new FormControl(this.selectedItem.id, Validators.required),
    });
    this.upiPayment = this.fb.group ({
      upi_number: new FormControl ('', Validators.required),
      upi_termCondtion: new FormControl('', Validators.required),
    });
    this.net_banking_Payment = this.fb.group ({
      net_banking_termCondtion: new FormControl ('', Validators.required),
      net_banking_number: new FormControl ('', Validators.required),
    })
  }

  public type$ = defer(() => this.card_number.valueChanges).pipe(
    map((num: string) => CreditCard.cardType(num))
  );

  ngOnInit(): void {
    this.rP = JSON.parse(localStorage.getItem('BoardPrice')!);
    this.ROOM = JSON.parse(localStorage.getItem('ROOMS')!);
  }

  paymentNow() {
    if(this.paymentForm.valid) {
      this.http.hotelsave(`booking/checkout`, this.paymentForm.value).subscribe( res => {
        if (res.status === 'Success'){
          this.payment = res.webview_url;
          this.optPaymentRoute = this.payment;
          window.open(this.optPaymentRoute, "_blank");
          let dialogRef = this.dialog.open(ProcessComponent, {});
          setTimeout(() => {
            dialogRef.close();
          }, 50000);
          // this.router.navigate(['../../acknowledgement'], { relativeTo: this.route });
          // this.util.showMsg(res.message);
        } else if (res.status_code !== 'Success') {
          // let dialogRef = this.dialog.open(ProcessComponent, {});
          // setTimeout(() => {
          //   dialogRef.close();
            this.router.navigate(['../../acknowledgement'], { relativeTo: this.route });
          // }, 15000);
        }
      }
      // , err => {
      //   this.errMsg = err?.error;
      //   console.log(this.errMsg);

      //   this.util.errorMessage(err);
      // }
      )
    } else {}
  }

  gstInfo(): void {
    const dialogRef = this.dialog.open(GSTComponent, {
      width: '480px',
    })
  }

  

  gstEdit() {
    const dialog = this.dialog.open(GSTComponent, {
      width: '480px',
      data: {
        gstList: this.list
      }
    })
  }

  removeList(item) {
    this.list.splice(item, 1);
  }

  select(newValue) {
    this.selectedItem = newValue;
  }

  selectUpi(newValue) {
    this.selectedItemUpi = newValue
  }

  selectNetBanking(newValue) {
    this.selectedItemNetBanking = newValue
  }

  submitWallet() {
    if(this.selectedItem.id) {
      console.log(this.selectedItem.id);
    } else {
      this.errMsg = 'Please Select Payment Mode.'
      this.util.showError('Please Select Payment Mode');
    }
  }

  submitUpi() {
    if(this.selectedItemUpi.id) {
      console.log(this.selectedItemUpi.name);
    } else {
      this.errMsg = 'Please Select Payment Mode.'
      this.util.showError('Please Select Payment Mode');
    }
  }

  submitNetBanking () {
    if(this.selectedItemNetBanking.id) {
      console.log(this.selectedItemNetBanking.name);
    } else {
      this.errMsg = 'Please Select Payment Mode.'
      this.util.showError('Please Select Payment Mode');
    }
  }

  view_qr_code(){

  }

  verify_pay(){

  }

  wallets_Banking_payment(){
    
  }

  selectWalletBanking(newValue){

  }

  onRadiowalletChange(event:any){
    this.selectedWallet = event.value.name;
    this.wallet_banking = event.value;
    console.log(this.selectedWallet)
  }

  internet_Banking_payment(){

  }

  onRadioChange(event:any){
    this.selectedBank = event.value.name;
    this.internet_banking_code = event.value;
    console.log(this.selectedBank)
  }

}
